import axios from 'axios' // 引用axios
import { Message, MessageBox } from 'element-ui'
import config from '@/utils/config'
import { getToken } from '@/utils/auth'
import { tansParams } from "@/utils/ruoyi";
import errorCode from '@/utils/errorCode'
import cache from '@/plugins/cache'
import { removeToken, setToken } from "./auth";
import router from '../router'

const _baseUrl = config.baseUrl.dev // 使用到代理
const apiUrl = _baseUrl
// axios 配置

const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分 --
  // baseURL: apiUrl,
  baseURL: 'https://tyj.ln.gov.cn/boot-admin/',
  // baseURL: 'http://112.91.140.52:82',
  // baseURL: 'http://192.168.0.4:8080/boot-admin/',
  // 超时
  timeout: 60000
})


// request拦截器
service.interceptors.request.use(config => {
  if (!config.config || !config.config.noLoading) {
    // console.log(getToken())
  }
  let token = getToken()
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  // 是否需要防止数据重复提交
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  if (token && !isToken) {
    config.headers['Authorization'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  config.headers['From-Type'] = 'cloud' // 请求来源
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url;                  // 请求地址
      const s_data = sessionObj.data;                // 请求数据
      const s_time = sessionObj.time;                // 请求时间
      const interval = 1000;                         // 间隔时间(ms)，小于此时间视为重复提交
      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        // const message = '数据正在处理，请勿重复提交';
        // return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    if (res.headers.authorization) {
      setToken(res.headers.authorization)
    }
    // 未设置状态码则默认成功状态
    const code = res.data.code || 0;
    // 获取错误信息
    const msg = errorCode[code] || res.data.message || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      return res.data
    }

    if (code === 401 || ((typeof res.data === 'string') && res.data.code === undefined)) {
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        removeToken()
        router.push({ path: '/login' })
      }).catch(() => {
      });
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
      Message({
        message: msg,
        type: 'error'
      })
      return Promise.reject(new Error(msg))
    } else if (code !== 0 && code !== 201) {
      Message({
        message: msg,
        type: 'error'
      })
      return Promise.reject(res.data)
    } else {
      return res.data
    }
  },
  error => {
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export function post (url, data, headers = {}, config) {
  return service({
    url: url,
    method: 'post',
    headers: headers,
    data: data,
    config: config
  })
}

export function put (url, data, headers = {}) {
  return service({
    url: url,
    method: 'put',
    headers: headers,
    data: data
  })
}

export function get (url, params, headers = {}, config) {
  return service({
    url: url,
    method: 'get',
    headers: headers,
    params: params,
    config: config
  })
}

export function del (url, params, headers = {}) {
  return service({
    url: url,
    method: 'delete',
    headers: headers,
    params: params
  })
}

export default service

